export default __webpack_public_path__ + "static/media/Ellipse 23 (1).c3badaec.png";